export type LegacyRedirect =
  | { to: string }
  | { resolveChannel: true; pospId: string };

export function legacyPospRedirect(role: string | undefined, id?: string): LegacyRedirect {
  if (role === 'posp' || role === 'super_posp') {
    return { to: id ? `/portal/${id}` : '/portal' };
  }
  // broker_admin / broker_employee (and any other role): route into Channels.
  if (id) return { resolveChannel: true, pospId: id };
  return { to: '/broker/channels?type=POSP' };
}
